import { observable, runInAction } from "mobx";

export const smartViewUnreadUpdateIds = observable.set<string>([], { deep: false });

export const setSmartViewUnreadUpdates = (smartViewIds: string[]) => {
  runInAction(() => {
    smartViewUnreadUpdateIds.clear();
    for (const smartViewId of smartViewIds) {
      smartViewUnreadUpdateIds.add(smartViewId);
    }
  });
};

export const hasSmartViewUnreadUpdate = (smartViewId: string): boolean => {
  return smartViewUnreadUpdateIds.has(smartViewId);
};

export const getSmartViewUpdateToastId = (smartViewId: string): string => {
  return `smart-view-update-${smartViewId}`;
};

export const getSmartViewIdFromPath = (path: string): string | null => {
  const pathname = path.split("?")[0];
  const match = pathname.match(/^\/smart-views\/([^/]+)$/);

  return match?.[1] ?? null;
};
